import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_RISK_AREA_OUTCOME_LIST } from "../services/get-risk-area-outcome-list";
import { GET_STATUS_LOOKUP_LIST } from "../../../external-audit/case-detail/case-data/services/get-audit-case-finding-status";
import { cloneDeep, cloneDeepWith } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_AUDIT_OUTCOME_LIST } from "../services/get-audit-outcome-list";
import { GET_RISK_AREA_TYPE_LIST } from "../services/get-risk-area-type-list";
import { GET_RISK_AREA_OUTCOME_STATUS_LIST } from "../services/get-risk-area-outcome-status-list";
export const TOGGLE_RAOUTCOME_LIST_ACTION_POPOVER =
  "TOGGLE_RAOUTCOME_LIST_ACTION_POPOVER";
export const TOGGLE_RISK_AREA_OUTCOME_POPUP = "TOGGLE_RISK_AREA_OUTCOME_POPUP";
export const SET_RISK_AREA_OUTCOME_FORM_DATA =
  "SET_RISK_AREA_OUTCOME_FORM_DATA";
export const RESET_RISK_AREA_OUTCOME_POPUP_VALIDATION =
  "RESET_RISK_AREA_OUTCOME_POPUP_VALIDATION";
export const SET_RISK_AREA_OUTCOME_STATUS_LIST ="SET_RISK_AREA_OUTCOME_STATUS_LIST";
export const defaultRiskAreaOutcomeFormData = {
  riskAreaOutcomeId: 0,
  auditOutcome: "",
  clientId: 0,
  curated: "",
  curatedInd:false,
  description: null,
  displayName: "",
  effectiveDate: new Date(),
  linkedRAStatusCd: "",
  name: "",
  outcomeType: null,
  riskAreaStatusId: 0,
  riskAreaTypeIds: [],
  termDate: null,
  updateDate: null,
  updatedBy: "",
  createDate: "",
  createdBy: "",
  auditOutcomeIds: [],
};
const initialState = {
  riskAreaOutcomeList: [],
  isLoading: false,
  riskAreaOutcomeFormData: defaultRiskAreaOutcomeFormData,
  statusList: [],
  auditOutcomeList: [],
  riskAreaTypeList: [],
  riskAreaTypeStatusList:[]
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_RISK_AREA_OUTCOME_LIST)(action)) {
        return {
          ...state,
          riskAreaOutcomeList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_RISK_AREA_OUTCOME_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          riskAreaOutcomeList: response.riskAreaOutcomeList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_AUDIT_OUTCOME_LIST)(action)) {
        return { ...state, auditOutcomeList: [] };
      }
      if (isAsyncComplete(GET_AUDIT_OUTCOME_LIST)(action)) {
        return { ...state, auditOutcomeList: action.response };
      }

      if (isAsyncOperation(GET_RISK_AREA_TYPE_LIST)(action)) {
        return { ...state, riskAreaTypeList: [] };
      }
      if (isAsyncComplete(GET_RISK_AREA_TYPE_LIST)(action)) {
        return { ...state, riskAreaTypeList: action.response };
      }
      if (isAsyncOperation(GET_RISK_AREA_OUTCOME_STATUS_LIST)(action)) {
        return { ...state, statusList: [] };
      }
      if (isAsyncComplete(GET_RISK_AREA_OUTCOME_STATUS_LIST)(action)) {
        const response = action.response;
        return { ...state, statusList: response.riskAreaOutcomeStatusAssociationList };
      }
      return state;
    case TOGGLE_RAOUTCOME_LIST_ACTION_POPOVER:
    case TOGGLE_RISK_AREA_OUTCOME_POPUP:
    case SET_RISK_AREA_OUTCOME_STATUS_LIST: 
      return { ...state, ...action.data };
    case SET_RISK_AREA_OUTCOME_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const riskAreaOutcomeFormData = newState.riskAreaOutcomeFormData
          ? newState.riskAreaOutcomeFormData
          : {};
        for (let prop in action.data.riskAreaOutcomeFormData) {
          riskAreaOutcomeFormData[prop] =
            action.data.riskAreaOutcomeFormData[prop];
          if (
            prop == "riskAreaTypeIds" &&
            action.data.riskAreaOutcomeFormData?.riskAreaTypeIds?.length == 0
          ) {
            riskAreaOutcomeFormData.riskAreaTypeIds = state.riskAreaTypeList?.map(
              (x) => x.riskAreaTypeId
            );
          }
        }
        newState = {
          ...newState,
          riskAreaOutcomeFormData: riskAreaOutcomeFormData,
        };
      }
      return newState;
    case RESET_RISK_AREA_OUTCOME_POPUP_VALIDATION:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    default:
      return state;
  }
}
